import {Button, setNotification} from '@startlibs/components'
import React from 'react'
import {CaseRequestCard} from '../CaseRequestCard'
import {ConfirmDialog, useConfirmDialog} from '../../hooks/useConfirmDialog'
import {getJwt} from '../../hooks/useJwt'
import {jwtFormFetcher} from '../../utils/authFetch'

export const useSetAsRequestedDialog = (caseRequest, onSuccess) => useConfirmDialog(
  <ConfirmDialog
    title={"Set case as Requested"}
    action={jwtFormFetcher(getJwt())("/api/admin/setAsRequested?requestId="+(caseRequest.requestId || caseRequest.id))}
    onSuccess={onSuccess}
    onFailure={() => setNotification({ type: "alert", msg: "Failed to set case as Requested" })}
    notify={"Case successfully set as Requested."}
    confirm={<Button highlight>{'Confirm'}</Button>}
  >
    <CaseRequestCard viewOnly caseRequest={caseRequest} isResults={true} />
    <p>Are you sure you want to set this case back to &quot;Requested&quot; status?</p>
  </ConfirmDialog>
)
